import ProfileDetailUserDataSubAccountsItemViewDetailedHeader from './ProfileDetailUserDataSubAccountsItemViewDetailedHeader';
import { UserProfileDetailsInfos } from '@/components/custom/userProfileDetails';
import { BadgeUserAccountStatus, UserPhotoGrid } from '@/components/custom';
import { UserAccountStatusEnum } from '@/enums';
import { IUserData } from '@/lib/interface';
import { Card } from '@/components/ui';

type TProps = {
	user: IUserData;
}

const ProfileDetailUserDataSubAccountsItemViewDetailed = ({ user }: TProps) => (
	<Card className='animate__animated animate__fadeIn relative'>
		<div className='flex flex-col space-y-4'>
			<ProfileDetailUserDataSubAccountsItemViewDetailedHeader user={user} />
			<div className={'flex flex-col space-y-4 justify-center px-2 md:px-4 pb-3'}>
				<UserPhotoGrid
					readonly
					userData={user as any} />
				<div className='flex flex-col space-y-1'>
					<UserProfileDetailsInfos
						hideDevicesCount
						hideCountry
						hideCoins
						hideAge
						align='center'
						userData={user as any}
						className='justify-center mx-auto' />
				</div>
			</div>
		</div>
		<BadgeUserAccountStatus
			user={user}
			title='Cet utilisateur est inactif'
			isVisible={l => l.accountStatus !== UserAccountStatusEnum.ACTIVE}
			className={'text-nowrap px-2 py-0.5 text-xs rounded-sm absolute -top-2 -right-1'} />
	</Card>
);

export default ProfileDetailUserDataSubAccountsItemViewDetailed;
